import {
  differenceInSeconds,
  startOfDay,
  endOfDay,
  addDays,
  subDays,
  startOfMonth,
  endOfMonth,
  subMonths,
  startOfWeek,
  endOfWeek,
  subWeeks,
  format,
  differenceInCalendarDays,
} from "date-fns";

import moment from "moment-timezone";
// import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
// import { useTheme } from "@mui/material";
// import useStyles from "@jumbo/vendors/sweetalert2/style";
// import Swal from "sweetalert2";
import {
  BANNER_PREVIEW_URL,
  DOMAIN_PREVIEW_URLS,
  CONFIGURATIONS,
} from "app/utils/constants/configurations";
import uuid from "react-uuid";
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";
import { countryListArray } from "app/components/publishers/AppValidation";
import cloneDeep from "lodash.clonedeep";
import MD5 from "crypto-js/md5";
import * as XLSX from "xlsx";
import { parseUrl } from "@aws-sdk/url-parser";
import { S3RequestPresigner } from "@aws-sdk/s3-request-presigner";
import { Sha256 } from "@aws-crypto/sha256-browser";
import { formatUrl } from "@aws-sdk/util-format-url";
import { HttpRequest } from "@aws-sdk/protocol-http";
import Papa from "papaparse";
import { DATASOURCE_CONFIG } from "app/config";
import axios from "axios";
import CryptoJS from "crypto-js";

let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
export const convertHexToRGB = (hex) => {
  // check if it's a rgba
  if (hex.match("rgba")) {
    let triplet = hex.slice(5).split(",").slice(0, -1).join(",");
    return triplet;
  }

  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = "0x" + c.join("");

    return [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",");
  }
};

export function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
}

export function isMobile() {
  if (window) {
    return window.matchMedia(`(max-width: 767px)`).matches;
  }
  return false;
}

export function isMdScreen() {
  if (window) {
    return window.matchMedia(`(max-width: 1199px)`).matches;
  }
  return false;
}

function currentYPosition(elm) {
  if (!window && !elm) {
    return;
  }
  if (elm) return elm.scrollTop;
  // Firefox, Chrome, Opera, Safari
  if (window.pageYOffset) return window.pageYOffset;
  // Internet Explorer 6 - standards mode
  if (document.documentElement && document.documentElement.scrollTop)
    return document.documentElement.scrollTop;
  // Internet Explorer 6, 7 and 8
  if (document.body.scrollTop) return document.body.scrollTop;
  return 0;
}

function elmYPosition(elm) {
  var y = elm.offsetTop;
  var node = elm;
  while (node.offsetParent && node.offsetParent !== document.body) {
    node = node.offsetParent;
    y += node.offsetTop;
  }
  return y;
}

export function scrollTo(scrollableElement, elmID) {
  var elm = document.getElementById(elmID);

  if (!elmID || !elm) {
    return;
  }

  var startY = currentYPosition(scrollableElement);
  var stopY = elmYPosition(elm);

  var distance = stopY > startY ? stopY - startY : startY - stopY;
  if (distance < 100) {
    scrollTo(0, stopY);
    return;
  }
  var speed = Math.round(distance / 50);
  if (speed >= 20) speed = 20;
  var step = Math.round(distance / 25);
  var leapY = stopY > startY ? startY + step : startY - step;
  var timer = 0;
  if (stopY > startY) {
    for (var i = startY; i < stopY; i += step) {
      setTimeout(
        (function (leapY) {
          return () => {
            scrollableElement.scrollTo(0, leapY);
          };
        })(leapY),
        timer * speed
      );
      leapY += step;
      if (leapY > stopY) leapY = stopY;
      timer++;
    }
    return;
  }
  for (let i = startY; i > stopY; i -= step) {
    setTimeout(
      (function (leapY) {
        return () => {
          scrollableElement.scrollTo(0, leapY);
        };
      })(leapY),
      timer * speed
    );
    leapY -= step;
    if (leapY < stopY) leapY = stopY;
    timer++;
  }
  return false;
}

export function getTimeDifference(date) {
  let difference = differenceInSeconds(new Date(), new Date(date));

  if (difference < 60) return `${Math.floor(difference)} sec`;
  else if (difference < 3600) return `${Math.floor(difference / 60)} min`;
  else if (difference < 86400) return `${Math.floor(difference / 3660)} h`;
  else if (difference < 86400 * 30)
    return `${Math.floor(difference / 86400)}d ago`;
  else if (difference < 86400 * 30 * 12)
    return `${Math.floor(difference / 86400 / 30)}mon ago`;
  else return `${(difference / 86400 / 30 / 12).toFixed(1)}y ago`;
}

export function generateRandomId() {
  let tempId = Math.random().toString();
  let uid = tempId.substr(2, tempId.length - 1);
  return uid;
}

export function getQueryParam(prop) {
  var params = {};
  var search = decodeURIComponent(
    window.location.href.slice(window.location.href.indexOf("?") + 1)
  );
  var definitions = search.split("&");
  definitions.forEach(function (val, key) {
    var parts = val.split("=", 2);
    params[parts[0]] = parts[1];
  });
  return prop && prop in params ? params[prop] : params;
}

export function classList(classes) {
  return Object.entries(classes)
    .filter((entry) => entry[1])
    .map((entry) => entry[0])
    .join(" ");
}

export const flat = (array) => {
  var result = [];
  array.forEach(function (a) {
    result.push(a);
    if (Array.isArray(a.children)) {
      result = result.concat(flat(a.children));
    }
  });
  return result;
};

export const toTitleCase = (str) => {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};
export const numberFormat = (num) => {
  const number = parseFloat(num);
  if (isNaN(number)) {
    return 0;
  }
  return number.toLocaleString("en-US", { maximumFractionDigits: 2 });
};
export const getRowConversionTotal = (row = {}, conversionFields = []) => {
  const fields =
    Array.isArray(conversionFields) && conversionFields.length
      ? conversionFields
      : Object.keys(row || {}).filter(
          (field) => field === "conversions" || field.startsWith("conversions_")
        );

  return fields.reduce(
    (total, field) => total + Number(row?.[field] || 0),
    0
  );
};
export const sortRowsByPerformancePriority = (
  rows = [],
  conversionFields = []
) => {
  return [...(rows || [])].sort((leftRow, rightRow) => {
    const conversionDiff =
      getRowConversionTotal(rightRow, conversionFields) -
      getRowConversionTotal(leftRow, conversionFields);
    if (conversionDiff !== 0) {
      return conversionDiff;
    }

    const clickDiff =
      Number(rightRow?.clicks || 0) - Number(leftRow?.clicks || 0);
    if (clickDiff !== 0) {
      return clickDiff;
    }

    return (
      Number(rightRow?.impressions || 0) - Number(leftRow?.impressions || 0)
    );
  });
};
export const getDashboardFilter = (type, date = "") => {
  const dateFilters = {};
  dateFilters.label = type;
  var selDate = new Date();
  if (date != "") {
    selDate = new Date(date);
  }
  if (type == "day") {
    dateFilters.startDate = format(startOfDay(selDate), "yyyy-MM-dd HH:mm:ss");
    dateFilters.endDate = format(endOfDay(selDate), "yyyy-MM-dd HH:mm:ss");
  } else if (type == "last_day") {
    dateFilters.startDate = format(
      startOfDay(subDays(selDate, 1)),
      "yyyy-MM-dd HH:mm:ss"
    );
    dateFilters.endDate = format(
      endOfDay(subDays(selDate, 1)),
      "yyyy-MM-dd HH:mm:ss"
    );
  } else if (type == "week") {
    dateFilters.startDate = format(startOfWeek(selDate), "yyyy-MM-dd HH:mm:ss");
    dateFilters.endDate = format(endOfWeek(selDate), "yyyy-MM-dd HH:mm:ss");
  } else if (type == "last_week") {
    dateFilters.startDate = format(
      startOfWeek(subWeeks(selDate, 1)),
      "yyyy-MM-dd HH:mm:ss"
    );
    dateFilters.endDate = format(
      endOfWeek(subWeeks(selDate, 1)),
      "yyyy-MM-dd HH:mm:ss"
    );
  } else if (type == "last_month") {
    dateFilters.startDate = format(
      startOfMonth(subWeeks(selDate, 1)),
      "yyyy-MM-dd HH:mm:ss"
    );
    dateFilters.endDate = format(
      endOfMonth(subWeeks(selDate, 1)),
      "yyyy-MM-dd HH:mm:ss"
    );
  }
  return dateFilters;
};
// export const customToast = (variant, message) => {
//   console.log("Message", message);
//   const sweetAlertStyles = useStyles;
//   const FinalSwal = Swal.mixin({
//     customClass: {
//       container: `${sweetAlertStyles.container}`,
//       popup: `${sweetAlertStyles.popup}`,
//       title: `${sweetAlertStyles.title}`,
//       closeButton: `${sweetAlertStyles.closeButton}`,
//       image: `${sweetAlertStyles.image}`,
//       htmlContainer: `${sweetAlertStyles.htmlContainer}`,
//       confirmButton: `${sweetAlertStyles.confirmButton}`,
//       cancelButton: `${sweetAlertStyles.cancelButton}`,
//       footer: `${sweetAlertStyles.footer}`,
//     },
//     buttonsStyling: false,
//   });
//   //const Swal = useSwalWrapper();
//   //const theme = useTheme();
//   //const sweetAlerts = (variant, message) => {
//   const Toast = FinalSwal.mixin({
//     toast: true,
//     position: "top-right",
//     showConfirmButton: false,
//     timer: 3000,
//     timerProgressBar: true,
//     onOpen: (toast) => {
//       toast.addEventListener("mouseenter", FinalSwal.stopTimer);
//       toast.addEventListener("mouseleave", FinalSwal.resumeTimer);
//     },
//   });

//   Toast.fire({
//     icon: variant,
//     title: message,
//     background: "#ccc",
//   });
//   // };
// };

export const countTrueElements = (json) => {
  let count = 0;
  for (const key in json) {
    if (json[key] === true) {
      count++;
    }
  }
  return count;
};

export const getTrueElements = (json) => {
  let elements = [];
  for (const key in json) {
    if (json[key] === true) {
      elements.push(CONFIGURATIONS.labels[key]);
    }
  }
  return elements;
};

export const convertTimezoneDatetoUtc = (
  timeZone = "UTC",
  date,
  showSeconds = true
) => {
  let utcTime = "";
  if (date != "") {
    let dateFormat = showSeconds ? "yyyy-MM-dd HH:mm:ss" : "yyyy-MM-dd HH:mm";
    let momentDateFormat = showSeconds
      ? "yyyy-MM-DD HH:mm:ss"
      : "yyyy-MM-DD HH:mm";
    if (timeZone == "" || timeZone == null || timeZone == undefined) {
      //utcTime = moment(date).format(format);

      utcTime = format(new Date(date), dateFormat);
    } else {
      // console.log("date:", date);
      //console.log("timeZone:", timeZone);
      //var dayTime = moment(date).tz(timeZone).format(momentDateFormat);

      var dayTime = moment.tz(date, timeZone);
      //console.log("dayTime:", dayTime);
      utcTime =
        timeZone == "UTC"
          ? format(new Date(date), dateFormat)
          : moment(dayTime).tz("UTC").format(momentDateFormat); //"yyyy-MM-DD HH:mm:ss"
    }
  }
  return utcTime;
};
export const getCurrentTimezoneDate = (
  timeZone = "UTC",
  format = "yyyy-MM-DD HH:mm:ss"
) => {
  const datetime = moment().tz(timeZone).format(format);
  if (datetime) {
    return datetime;
  } else {
    return "";
  }
};
export const convertDateFormat = (date, dtFormat = "YYYY-MM-DD HH:mm:ss") => {
  var finalDate = "";
  // if (dtFormat == "yyyy-MM-dd HH:mm:ss") {
  //   dtFormat = "yyyy-MM-DD HH:mm:ss";
  // } else if (dtFormat == "yyyy-MM-dd'T'HH:mm:ss") {
  //   dtFormat = "yyyy-MM-DD'T'HH:mm:ss";
  // }

  if (date != "" && date != null && date != undefined) {
    //finalDate = format(new Date(date), dtFormat);
    // finalDate = moment
    //   .tz(new Date(date), "YYYY-MM-DD HH:mm:ss", "UTC")
    //   .format("YYYY-MM-DD HH:mm:ss");
    //const timezoneOffset = (new Date()).getTimezoneOffset();
    // date = new Date(date).toISOString().replace("T", " ").replace("Z", "");
    if (dtFormat == "") {
      finalDate = moment(date).format("YYYY-MM-DD HH:mm:ss");
    } else {
      finalDate = moment(date).format(dtFormat);
    }
  }
  return finalDate;
};

export const formatDashboardGraphDateLabel = (date) => {
  const parsedDate = moment(date, "YYYY-MM-DD", true);
  return parsedDate.isValid() ? parsedDate.format("MMM D") : date;
};
export const userAssocData = (data, id) => {
  //Publisher Assoc

  let companies = data.company;
  let accounts = data.accounts;
  let publishers = data.publishers;
  let valArr = [];

  if (companies != "" && companies != null && companies != undefined) {
    let company_id = companies.value;

    if (accounts.length == 0 && publishers.length == 0) {
      valArr.push("('" + id + "','publisher','-1','-1','" + company_id + "')");
    } else if (accounts.length > 0) {
      accounts.map((accInfo) => {
        if (publishers.length > 0) {
          publishers.map((pubInfo) => {
            if (pubInfo.account_id == accInfo.value) {
              valArr.push(
                "('" +
                  id +
                  "','publisher','" +
                  pubInfo.value +
                  "','" +
                  accInfo.value +
                  "','" +
                  company_id +
                  "')"
              );
            }
            // } else if (accInfo.company_id == company_id) {
            //   valArr.push(
            //     "('" +
            //       id +
            //       "','publisher','-1','" +
            //       accInfo.value +
            //       "','" +
            //       company_id +
            //       "')"
            //   );
            // }
          });
        } else if (accInfo.company_id == company_id) {
          valArr.push(
            "('" +
              id +
              "','publisher','-1','" +
              accInfo.value +
              "','" +
              company_id +
              "')"
          );
        }
      });
    } else if (publishers.length > 0) {
      publishers.map((pubInfo) => {
        valArr.push(
          "('" +
            id +
            "','publisher','" +
            pubInfo.value +
            "','-1','" +
            company_id +
            "')"
        );
      });
    }
  } else if (accounts.length > 0) {
    accounts.map((accInfo) => {
      if (publishers.length > 0) {
        publishers.some((pubInfo) => {
          if (pubInfo.account_id == accInfo.value) {
            valArr.push(
              "('" +
                id +
                "','publisher','" +
                pubInfo.value +
                "','" +
                accInfo.value +
                "','-1')"
            );
          } else {
            valArr.push(
              "('" + id + "','publisher','-1','" + accInfo.value + "','-1')"
            );
          }
        });
      } else {
        valArr.push(
          "('" + id + "','publisher','-1','" + accInfo.value + "','-1')"
        );
      }
    });
  } else if (publishers.length > 0) {
    publishers.map((pubInfo) => {
      valArr.push(
        "('" + id + "','publisher','" + pubInfo.value + "','-1','-1')"
      );
    });
  }

  //Advertiser - Assoc
  let advCompanies = data.advCompany;
  let advAccounts = data.advAccounts;
  let advertisers = data.advertisers;
  if (advCompanies != "" && advCompanies != null && advCompanies != undefined) {
    let company_id = advCompanies.value;

    if (advAccounts.length == 0 && advertisers.length == 0) {
      valArr.push("('" + id + "','advertiser','-1','-1','" + company_id + "')");
    } else if (advAccounts.length > 0) {
      advAccounts.map((accInfo) => {
        if (advertisers.length > 0) {
          advertisers.map((advInfo) => {
            if (advInfo.account_id == accInfo.value) {
              valArr.push(
                "('" +
                  id +
                  "','advertiser','" +
                  advInfo.value +
                  "','" +
                  accInfo.value +
                  "','" +
                  company_id +
                  "')"
              );
            }
            // else if (accInfo.company_id == company_id) {
            //   valArr.push(
            //     "('" +
            //       id +
            //       "','advertiser','-1','" +
            //       accInfo.value +
            //       "','" +
            //       company_id +
            //       "')"
            //   );
            // }
          });
        } else if (accInfo.company_id == company_id) {
          valArr.push(
            "('" +
              id +
              "','advertiser','-1','" +
              accInfo.value +
              "','" +
              company_id +
              "')"
          );
        }
      });
    } else if (advertisers.length > 0) {
      advertisers.map((advInfo) => {
        valArr.push(
          "('" +
            id +
            "','advertiser','" +
            advInfo.value +
            "','-1','" +
            company_id +
            "')"
        );
      });
    }
  } else if (advAccounts.length > 0) {
    advAccounts.map((accInfo) => {
      if (advertisers.length > 0) {
        advertisers.some((advInfo) => {
          if (advInfo.account_id == accInfo.value) {
            valArr.push(
              "('" +
                id +
                "','advertiser','" +
                advInfo.value +
                "','" +
                accInfo.value +
                "','-1')"
            );
          } else {
            valArr.push(
              "('" + id + "','advertiser','-1','" + accInfo.value + "','-1')"
            );
          }
        });
      } else {
        valArr.push(
          "('" + id + "','advertiser','-1','" + accInfo.value + "','-1')"
        );
      }
    });
  } else if (advertisers.length > 0) {
    advertisers.map((advInfo) => {
      valArr.push(
        "('" + id + "','advertiser','" + advInfo.value + "','-1','-1')"
      );
    });
  }

  //Bidder - Assoc
  let bidCompanies = data.bidCompany;
  let bidAccounts = data.bidAccounts;
  let bidders = data.bidders;
  if (bidCompanies != "" && bidCompanies != null && bidCompanies != undefined) {
    let company_id = bidCompanies.value;

    if (bidAccounts.length == 0 && bidders.length == 0) {
      valArr.push("('" + id + "','bidder','-1','-1','" + company_id + "')");
    } else if (bidAccounts.length > 0) {
      bidAccounts.map((accInfo) => {
        if (bidders.length > 0) {
          bidders.map((bidInfo) => {
            if (bidInfo.accountid == accInfo.value) {
              valArr.push(
                "('" +
                  id +
                  "','bidder','" +
                  bidInfo.value +
                  "','" +
                  accInfo.value +
                  "','" +
                  company_id +
                  "')"
              );
            }
          });
        } else if (accInfo.company_id == company_id) {
          valArr.push(
            "('" +
              id +
              "','bidder','-1','" +
              accInfo.value +
              "','" +
              company_id +
              "')"
          );
        }
      });
    } else if (bidders.length > 0) {
      bidders.map((bInfo) => {
        valArr.push(
          "('" +
            id +
            "','bidder','" +
            bInfo.value +
            "','-1','" +
            company_id +
            "')"
        );
      });
    }
  } else if (bidAccounts.length > 0) {
    bidAccounts.map((accInfo) => {
      if (bidders.length > 0) {
        bidders.some((bInfo) => {
          if (bInfo.accountid == accInfo.value) {
            valArr.push(
              "('" +
                id +
                "','bidder','" +
                bInfo.value +
                "','" +
                accInfo.value +
                "','-1')"
            );
          } else {
            valArr.push(
              "('" + id + "','bidder','-1','" + accInfo.value + "','-1')"
            );
          }
        });
      } else {
        valArr.push(
          "('" + id + "','bidder','-1','" + accInfo.value + "','-1')"
        );
      }
    });
  } else if (bidders.length > 0) {
    bidders.map((bInfo) => {
      valArr.push("('" + id + "','bidder','" + bInfo.value + "','-1','-1')");
    });
  }

  if (valArr.length == 0) {
    valArr.push("('" + id + "','publisher','-1','-1','-1')");
    valArr.push("('" + id + "','advertiser','-1','-1','-1')");
    valArr.push("('" + id + "','bidder','-1','-1','-1')");
  }

  return valArr;
};

export const multipleSelectValues = (lists, valArr) => {
  let listArr = lists.filter((info) => {
    if (valArr.includes(info.value)) {
      return info;
    }
  });
  return listArr;
};

export const singleSelectValues = (lists, value) => {
  let obj =
    lists[
      lists
        .map(function (item) {
          return item.value;
        })
        .indexOf(value)
    ];
  return obj;
};

export const getValuesFromArrayObject = (list, column, resType = "string") => {
  var values = [];
  for (var i = 0; i < list.length; i++) {
    var info = list[i];
    if (info && info.hasOwnProperty(column)) {
      values.push(info[column]);
    }
  }

  if (resType == "string") {
    return values.join(",");
  } else {
    return values;
  }
};

export const getIncludeExcludeValuesFromArrayObject = (
  list,
  column,
  resType = "string",
  excluded = false
) => {
  var values = [];
  for (var i = 0; i < list.length; i++) {
    var info = list[i];
    if (info && info.hasOwnProperty(column)) {
      if (excluded) {
        values.push("!" + info[column]);
      } else {
        values.push(info[column]);
      }
    }
  }

  if (resType == "string") {
    return values.join(",");
  } else {
    return values;
  }
};

export const publisherCrmsAssocData = (crmData, pub_id, accountid) => {
  let crmInfo = [];
  {
    crmData.map((info, i) => {
      let crmUnqId = uuid();
      let credential_json = {
        credential_json: "" + info.creditionalJson + "",
        db_url: "" + info.databaseUrl + "",
        table_ref: "" + info.tableName + "",
      };
      crmInfo.push(
        "('" +
          crmUnqId +
          "','" +
          pub_id +
          "','" +
          accountid +
          "','" +
          JSON.stringify(credential_json) +
          "','" +
          info.crmId +
          "'," +
          DATASOURCE_CONFIG.CURRENT_DATE +
          ")"
      );
    });
  }
  return crmInfo;
};
export const publisherPlacementAssocData = (
  appData,
  id,
  pub_code,
  accoutid
) => {
  let appInfo = [];
  let placementInfoValues = [];
  {
    appData.map((info) => {
      appInfo.push(
        "('" +
          info.id +
          "','" +
          pub_code +
          "','" +
          info.appUrl +
          "','" +
          info.app +
          "')"
      );
      {
        info.placementInfo.map((placeInfo) => {
          let countriesList;
          let countries = {};
          {
            placeInfo.countryWiseInfo.map((countyInfo) => {
              //countriesList = countryListArray(countyInfo.country);
              //var countriesKey = countriesList.join(",");
              //for (var k = 0; k < countriesList.length; k++) {
              countries[countyInfo.country] = countyInfo.adSizes;
              //}
              //adSizesArr.push(countyInfo.adSizes)
            });
          }
          let countriesjson = JSON.stringify(countries);
          placementInfoValues.push(
            "('" +
              placeInfo.id +
              "','" +
              pub_code +
              "','" +
              placeInfo.placementName +
              "','" +
              accoutid +
              "','" +
              placeInfo.partnerTagId +
              "','" +
              info.id +
              "','" +
              countriesjson +
              "')"
          );
        });
      }
    });
  }

  let pubInfo = {
    apps: appInfo.join(","),
    placements: placementInfoValues.join(","),
  };

  return pubInfo;
};

export const PublisherCrmsAssocData = (crmData, pub_id, accountid) => {
  let crmInfo = {
    info: "",
    query: "",
  };
  let crmInfoQuery = [];
  {
    crmData.map((cinfo) => {
      if (cinfo.id != "" && cinfo.delete == true) {
        let deleteCrm = {
          query:
            "update " +
            tablePrefix +
            "crm_sources_pub_assoc set status='0' where id='" +
            cinfo.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        };
        crmInfoQuery.push(deleteCrm);
      }

      if (cinfo.id != "" && cinfo.delete == false) {
        let credential_json = {
          credential_json: "" + cinfo.creditionalJson + "",
          db_url: "" + cinfo.databaseUrl + "",
          table_ref: "" + cinfo.tableName + "",
        };
        let updateCrm = {
          query:
            "update " +
            tablePrefix +
            "crm_sources_pub_assoc set crm_credentials='" +
            JSON.stringify(credential_json) +
            "' where id='" +
            cinfo.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        };
        crmInfoQuery.push(updateCrm);
      }
      if (cinfo.id == "" && cinfo.delete == false) {
        let crmUnqId = uuid();
        let credential_json = {
          credential_json: "" + cinfo.creditionalJson + "",
          db_url: "" + cinfo.databaseUrl + "",
          table_ref: "" + cinfo.tableName + "",
        };
        let insertCrm = {
          query:
            "insert into " +
            tablePrefix +
            "crm_sources_pub_assoc (id,pub_id,account_id,crm_credentials,crm_source_id,creation_date) values ('" +
            crmUnqId +
            "','" +
            pub_id +
            "','" +
            accountid +
            "','" +
            JSON.stringify(credential_json) +
            "','" +
            cinfo.crmId +
            "'," +
            DATASOURCE_CONFIG.CURRENT_DATE +
            ")",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        };
        cinfo.id = crmUnqId;
        crmInfoQuery.push(insertCrm);
      }
      return cinfo;
    });
  }

  crmInfo = {
    info: crmData,
    query: crmInfoQuery,
  };

  return crmInfo;
};

export const PublisherPlacementAssocData = (
  appData,
  pub_id,
  pub_code,
  accoutid
) => {
  let appQuery = [];
  let pubAppInfo = {
    info: "",
    query: "",
  };

  appData.map((appInfo) => {
    let appUnqId = uuid();
    if (appInfo.delete == true && appInfo.id != "") {
      let deleteapp = {
        query:
          "update " +
          tablePrefix +
          "publisher_apps set status='1' where id='" +
          appInfo.id +
          "'",
        datasource: DATASOURCE_CONFIG.DATASOURCE,
      };
      appQuery.push(deleteapp);
    }
    if (appInfo.id != "" && appInfo.delete == false) {
      let updateapp = {
        query:
          "update " +
          tablePrefix +
          "publisher_apps set pub_code='" +
          pub_code +
          "',url='" +
          appInfo.appUrl +
          "',type='" +
          appInfo.app +
          "',app_details='" +
          appInfo.details +
          "' where id='" +
          appInfo.id +
          "'",
        datasource: DATASOURCE_CONFIG.DATASOURCE,
      };
      appQuery.push(updateapp);
    }

    appInfo.placementInfo.map((placeInfo) => {
      let placementUnqId = uuid();

      if (
        placeInfo.id != "" &&
        (placeInfo.delete == true || appInfo.delete == true)
      ) {
        let deleteplace = {
          query:
            "update " +
            tablePrefix +
            "publisher_placements set is_deleted='1' where id='" +
            placeInfo.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        };
        appQuery.push(deleteplace);
      }

      let countries = {};

      placeInfo.countryWiseInfo.map((countyInfo) => {
        if (countyInfo.country != "") {
          countries[countyInfo.country] = countyInfo.adSizes;
        }
      });

      let countriesjson = JSON.stringify(countries);
      countriesjson = countriesjson == undefined ? "" : countriesjson;

      if (
        placeInfo.id != "" &&
        placeInfo.delete == false &&
        appInfo.delete == false
      ) {
        let updateplace = {
          query:
            "update " +
            tablePrefix +
            "publisher_placements set name='" +
            placeInfo.placementName +
            "',partner_tag_id='" +
            placeInfo.partnerTagId +
            "',floors='" +
            countriesjson +
            "' where id='" +
            placeInfo.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        };
        appQuery.push(updateplace);
      }

      if (
        placeInfo.id == "" &&
        placeInfo.delete == false &&
        appInfo.delete == false
      ) {
        let appId = appInfo.id == "" ? appUnqId : appInfo.id;

        let insertplace = {
          query:
            "insert into " +
            tablePrefix +
            "publisher_placements (id,pub_code,name,accountid,partner_tag_id,pub_app_id,floors) values ('" +
            placementUnqId +
            "','" +
            pub_code +
            "','" +
            placeInfo.placementName +
            "','" +
            accoutid +
            "','" +
            placeInfo.partnerTagId +
            "','" +
            appId +
            "','" +
            countriesjson +
            "')",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        };
        placeInfo.id = placementUnqId;
        appQuery.push(insertplace);
      }
    });

    if (appInfo.id == "" && appInfo.delete == false) {
      let appDetailsjson = JSON.stringify(appInfo.details);
      appDetailsjson = appDetailsjson == undefined ? "" : appDetailsjson;
      let insertapp = {
        query:
          "insert into " +
          tablePrefix +
          "publisher_apps (id,pub_code,url,type,app_details) values ('" +
          appUnqId +
          "','" +
          pub_code +
          "','" +
          appInfo.appUrl +
          "','" +
          appInfo.app +
          "','" +
          appInfo.details +
          "')",
        datasource: DATASOURCE_CONFIG.DATASOURCE,
      };
      appInfo.id = appUnqId;
      appQuery.push(insertapp);
    }

    return appInfo;
  });

  pubAppInfo = {
    info: appData,
    query: appQuery,
  };

  return pubAppInfo;
};

export const getDaysDifference = (endDate, startDate) => {
  var diff = 0;
  if (startDate != "" && endDate != "") {
    diff = differenceInCalendarDays(new Date(endDate), new Date(startDate));
  }
  return diff;
};

export const getCalendarDaysDifference = (endDate, startDate) => {
  var diff = 0;
  if (startDate != "" && endDate != "") {
    diff = calculateDifference(new Date(endDate), new Date(startDate));
  }
  // console.log("startDate:", startDate);
  // console.log("endDate:", endDate);
  // console.log("Days diff:", diff);
  return diff;
};

//this is to get the calendar days difference- not based on hours.
export const calculateDifference = (endDate, startDate) => {
  // Set hours, minutes, seconds, and milliseconds to 0

  let endDateMinutes = endDate.getMinutes();
  let endDateHours = endDate.getHours();

  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(23, 59, 59, 0);

  // if (endDateMinutes > 0) {
  //   endDate.setHours(23, 59, 59, 0);
  // } else {
  //   endDate.setHours(0, 0, 0, 0);
  // }

  // console.log("S:", startDate);
  // console.log("E", endDate);
  // Calculate the difference in days
  const difference = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
  //console.log("difference:", difference);
  return difference;
};

export const PublisherEmailData = (emailData, pub_code) => {
  let emailQuery = [];
  let pubEmailInfo = {
    info: "",
    query: "",
  };

  {
    emailData.map((info) => {
      if (info.id != "") {
        let id = info["id"];
        let emailInfo = cloneDeep(info);
        delete emailInfo["id"];
        let updateEmail = {
          query:
            "update " +
            tablePrefix +
            "publisher_request_auth set email_auth='" +
            JSON.stringify(emailInfo) +
            "' where id='" +
            id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        };
        emailQuery.push(updateEmail);
      }

      if (info.id == "") {
        let emailUnqId = uuid();
        let emailInfo = info;
        delete emailInfo["id"];
        let insertEmail = {
          query:
            "insert into " +
            tablePrefix +
            "publisher_request_auth (id,pub_code,email_auth) values('" +
            emailUnqId +
            "','" +
            pub_code +
            "','" +
            JSON.stringify(emailInfo) +
            "')",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        };
        emailQuery.push(insertEmail);
        info.id = emailUnqId;
      }
    });
  }

  pubEmailInfo = {
    info: emailData,
    query: emailQuery,
  };
  return pubEmailInfo;
};

export const readCsvFile = async (url = "") => {
  let presignedUrl = await getPresignedAmazon(url);

  return new Promise((resolve, reject) => {
    Papa.parse(presignedUrl, {
      download: true,
      header: false,
      complete(results, url) {
        resolve(results.data);
      },
      error(err, url) {
        reject(err);
      },
    });
  });
};

export const readS3KlmFile = async (s3URl, limit = "") => {
  // var parser = new DOMParser();
  let s3file = await getPresignedAmazon(s3URl);
  var polyPreview = [];
  var response = await fetch(s3file);
  var text = await response.text();

  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(text, "text/xml");
  var googlePolygons = [];
  var googlePolygonNames = [];
  var googlePolyFinalObj = {};
  var isValid = 1;
  var drawnPolygons = 0;

  if (xmlDoc.documentElement.nodeName == "kml") {
    for (var item of xmlDoc.getElementsByTagName("Placemark")) {
      if (drawnPolygons > 5) {
        break;
      }
      var polygonName = item
        .getElementsByTagName("name")[0]
        .childNodes[0].nodeValue.trim();
      var polygonAddress = item
        .getElementsByTagName("address")[0]
        .childNodes[0].nodeValue.trim();
      var polygonCountryCode = item
        .getElementsByTagName("countrycode")[0]
        .childNodes[0].nodeValue.trim();
      var polygons = item.getElementsByTagName("Polygon");

      if (polygons.length > 0) {
        /** POLYGONS PARSE **/
        for (var polygon of polygons) {
          var coords = polygon
            .getElementsByTagName("coordinates")[0]
            .childNodes[0].nodeValue.trim();
          var points = coords.split("\n");

          //console.log("points:", points);
          var googlePolygonsPaths = [];
          var polyIDMapping = [];
          var polygonCoordsForCenter = [];
          for (var point of points) {
            point = point.trim();
            var coord = point.split(",");

            polyIDMapping.push(coord[1] + " " + coord[0]);
            googlePolygonsPaths.push({
              lat: parseFloat(coord[1]),
              lng: parseFloat(coord[0]),
            });
            // polygonCoordsForCenter.push(
            //   new window.google.maps.LatLng(coord[1], coord[0])
            // );
          }

          var eleName = polyIDMapping.join(",") + ":" + polygonName;

          // var bounds = new window.google.maps.LatLngBounds();
          // for (var p = 0; p < polygonCoordsForCenter.length; p++) {
          //   bounds.extend(polygonCoordsForCenter[p]);
          // }
          //var center = bounds.getCenter();

          var id = MD5(eleName.toLowerCase());
          if (!googlePolyFinalObj.hasOwnProperty(id)) {
            googlePolyFinalObj[id] = {};
          }
          googlePolyFinalObj[id]["pn"] = googlePolygonsPaths;
          googlePolyFinalObj[id]["name"] = polygonName;
          googlePolyFinalObj[id]["address"] = polygonAddress;
          googlePolyFinalObj[id]["countrycode"] = polygonCountryCode;
          //googlePolyFinalObj[id]["lat"] = center.lat();
          //googlePolyFinalObj[id]["lon"] = center.lng();

          polyPreview.push({
            name: polygonName,
            //center: { lat: center.lat(), lng: center.lng() },
            coords: googlePolygonsPaths,
          });
          drawnPolygons++;
          if (limit != "" && limit > 0) {
            if (drawnPolygons > limit) {
              break;
            }
          }
        }
      }
    }

    /**Preview */
  } else {
    isValid = 0;
    console.log(
      "error",
      "There is some issue with the KML file. It seems, the KML file is corrupted. Please cross check sample file for mandatory fields."
    );
  }
  // });
  console.log("Preading Preview Polygons:", polyPreview);
  return polyPreview;
};

export const AudienceCrmsAssocData = (crmData, aud_id) => {
  let crmInfo = {
    info: "",
    query: "",
  };
  let crmInfoQuery = [];
  {
    crmData.map((cinfo) => {
      if (cinfo.id != "" && cinfo.delete == true) {
        let deleteCrm = {
          query:
            "update " +
            tablePrefix +
            "crm_sources_audience_assoc set status='0' where id='" +
            cinfo.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        };
        crmInfoQuery.push(deleteCrm);
      }

      if (cinfo.id != "" && cinfo.delete == false) {
        let credential_json = {
          credential_json: "" + cinfo.creditionalJson + "",
          db_url: "" + cinfo.databaseUrl + "",
          table_ref: "" + cinfo.tableName + "",
        };
        let updateCrm = {
          query:
            "update " +
            tablePrefix +
            "crm_sources_audience_assoc set crm_credentials='" +
            JSON.stringify(credential_json) +
            "' where id='" +
            cinfo.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        };
        crmInfoQuery.push(updateCrm);
      }
      if (cinfo.id == "" && cinfo.delete == false) {
        let crmUnqId = uuid();
        let credential_json = {
          credential_json: "" + cinfo.creditionalJson + "",
          db_url: "" + cinfo.databaseUrl + "",
          table_ref: "" + cinfo.tableName + "",
        };
        let insertCrm = {
          query:
            "insert into " +
            tablePrefix +
            "crm_sources_audience_assoc (id,audience_id,crm_credentials,crm_source_id,creation_date) values ('" +
            crmUnqId +
            "','" +
            aud_id +
            "','" +
            JSON.stringify(credential_json) +
            "','" +
            cinfo.crmId +
            "'," +
            DATASOURCE_CONFIG.CURRENT_DATE +
            ")",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        };
        cinfo.id = crmUnqId;
        crmInfoQuery.push(insertCrm);
      }
      return cinfo;
    });
  }

  crmInfo = {
    info: crmData,
    query: crmInfoQuery,
  };

  return crmInfo;
};

export const getDomainFromURL = (weburl) => {
  var url = String(weburl);
  var domain = "";
  var match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
  if (
    /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/.test(url) ||
    (match != null &&
      match.length > 2 &&
      typeof match[2] === "string" &&
      match[2].length > 0)
  ) {
    var t = url;
    if (
      /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/.test(url)
    ) {
      t = url;
    } else {
      t = match[2];
    }
    domain = t;
  }
  return domain;
};
export const numberWithCommas = (x) => {
  return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0";
};

export const getMinutesDifference = (milliseconds) => {
  var currentMilliseconds = moment().format("x");
  var minutes = moment().format("x");
  if (milliseconds) {
    minutes = (currentMilliseconds - milliseconds) / 60000;
    return minutes.toFixed(2);
  }
  return 0;
};

// Utility function to convert string to array buffer
function s2ab(s) {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i < s.length; i++) {
    view[i] = s.charCodeAt(i) & 0xff;
  }
  return buf;
}

export const downloadJSONAsXLSX = (data, filename) => {
  // Convert JSON data to XLSX format
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  const xlsxFile = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });

  // Trigger file download
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.href = URL.createObjectURL(
    new Blob([s2ab(xlsxFile)], { type: "application/octet-stream" })
  );
  a.download = filename;
  a.click();
  document.body.removeChild(a);
};

export const buildVisibleColumnExportRows = (
  rows = [],
  columns = [],
  valueResolver
) => {
  if (!Array.isArray(rows) || !Array.isArray(columns) || columns.length <= 0) {
    return rows;
  }

  return rows.map((row, rowIndex) => {
    const exportRow = {};

    columns.forEach((column) => {
      if (!column?.field || column.hide === true) {
        return;
      }

      const exportKey = column.headerName || column.field;
      let value;

      if (typeof column.exportValue === "function") {
        value = column.exportValue(row, rowIndex);
      } else if (typeof valueResolver === "function") {
        value = valueResolver(column, row, rowIndex);
      } else {
        value = row?.[column.field];
      }

      exportRow[exportKey] =
        value === undefined || value === null ? "" : value;
    });

    return exportRow;
  });
};

export const downloadJSONToCSV = (jsonData, filename) => {
  const items = jsonData;
  const replacer = (key, value) => (value === null ? "" : value);
  const header = Object.keys(items[0]);
  const csv = [
    header.join(","),
    ...items.map((row) =>
      header
        .map((fieldName) => JSON.stringify(row[fieldName], replacer))
        .join(",")
    ),
  ].join("\r\n");

  console.log("Csv", csv);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const downloadLink = document.createElement("a");
  downloadLink.href = url;
  downloadLink.download = filename;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};

// const credentials = {
//   accessKeyId: "AKIAS7MJ7EWCLB45COYR",
//   secretAccessKey: "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",
// };

// const region = "us-east-1";
// const bucket = "avng";

export const s3Credentials = {
  bucketName: "avng",
  region: "us-east-1",
  accessKeyId: "aaa", //added dummy keys
  secretAccessKey: "bbb", //added dummy keys
};

export const getPresignedAmazon = async (url) => {
  let credentials = s3Credentials;
  let region = credentials.region;
  const rawUrl = String(url || "").trim();
  if (rawUrl === "") {
    return false;
  }

  let bucketName = credentials.bucketName;
  let key = "";

  if (rawUrl.startsWith("s3://")) {
    const s3WithoutScheme = rawUrl.replace("s3://", "");
    const firstSlashIndex = s3WithoutScheme.indexOf("/");
    if (firstSlashIndex === -1) {
      return false;
    }
    bucketName = s3WithoutScheme.slice(0, firstSlashIndex) || bucketName;
    key = s3WithoutScheme.slice(firstSlashIndex + 1);
  } else if (rawUrl.startsWith("https://")) {
    const parsedUrl = parseUrl(rawUrl);
    const hostParts = String(parsedUrl.hostname || "").split(".");
    if (hostParts.length > 0 && hostParts[0] !== "") {
      bucketName = hostParts[0];
    }
    key = String(parsedUrl.path || "").replace(/^\/+/, "");
  } else {
    key = rawUrl;
  }

  key = key.replace("https://assets.avng-cdn.com/", "");
  key = key.replace(/^\/+/, "");
  if (key != "") {
    const s3ObjectUrl = parseUrl(
      `https://${bucketName}.s3.${region}.amazonaws.com/${key}`
    );

    const presigner = new S3RequestPresigner({
      credentials,
      region,
      sha256: Sha256, // In browsers
    });
    // Create a GET request from S3 url.
    const url = await presigner.presign(new HttpRequest(s3ObjectUrl));
    let finalUrl = formatUrl(url);
    return finalUrl;
  } else {
    return false;
  }
};

export const removeISOString = (date) => {
  return new Date(date)
    .toISOString()
    .replace("T", " ")
    .replace("Z", "")
    .replace(/[.]\d+/, "");
};

export const nFormatter = (num, digits) => {
  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "K" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "B" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" },
  ];

  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;

  var item = lookup
    .slice()
    .reverse()
    .find(function (item) {
      return num >= item.value;
    });

  return item
    ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol
    : num != null && num != undefined
    ? num.toFixed(digits)
    : num;
};

export const randomNumber = () => {
  return Math.floor(Math.random() * 1000000) + 1;
};
export const generateUniqueNumber = (length = 6, prefix = "") => {
  var newUniqueId = randomString(
    length,
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890"
  );
  return prefix != "" && prefix != null
    ? prefix + "" + newUniqueId
    : newUniqueId;
};
export const randomString = (length, chars) => {
  var result = "";
  for (var i = length; i > 0; --i)
    result += chars[Math.round(Math.random() * (chars.length - 1))];
  return result;
};

/****** DATE RELATED FUNCTIONS   ******/

export const generateQueryStartEndDates = (startdate, enddate) => {
  let dateInfo = {};
  let startdate_for_query = convertDateFormat(startOfDay(new Date(startdate)));
  let enddate_for_query = convertDateFormat(startOfDay(new Date(enddate)));
  enddate_for_query = convertDateFormat(
    addDays(new Date(enddate_for_query), 1)
  );

  dateInfo["startdate_for_query"] = startdate_for_query;
  dateInfo["enddate_for_query"] = enddate_for_query;

  return dateInfo;
};

export const convertUTCtoLocalTimezone = (utcDate, timezone) => {
  if (timezone == "" || timezone == null) {
    timezone = "UTC";
  }
  console.log("UTC TIME:", utcDate);
  console.log("timezone", timezone);
  //let localTime = moment(utcDate).tz(timezone).format("YYYY-MM-DD HH:mm:ss");
  //Converting UTC Timezone date to Timezone specified in the variable.
  let localTime = moment
    .tz(utcDate, "YYYY-MM-DD HH:mm:ss", "UTC")
    .tz(timezone)
    .format("YYYY-MM-DD HH:mm:ss");
  return localTime;
};
export const addslashes = (string) => {
  return string
    .replace(/\\/g, "\\\\")
    .replace(/\u0008/g, "\\b")
    .replace(/\t/g, "\\t")
    .replace(/\n/g, "\\n")
    .replace(/\f/g, "\\f")
    .replace(/\r/g, "\\r")
    .replace(/'/g, "\\'")
    .replace(/"/g, '\\"');
};

export const parseJsonString = (str, errorReturn = {}) => {
  try {
    const jsonObj = JSON.parse(str);
    if (typeof jsonObj == "object") {
      return jsonObj;
    } else {
      return errorReturn;
    }
  } catch (e) {
    return errorReturn;
  }
};
export const getIPAddress = async () => {
  const res = await axios.get("https://api.ipify.org/?format=json");

  //var response = await fetch(res);
  //var text = await response.json();
  //console.log("Iptext:", response);
  if (res?.data?.ip) {
    //console.log("res.data:", res.data);
    return res.data.ip;
  } else {
    return "";
  }
};

export const getIPLocation = async (ipAddress) => {
  const res = await axios.get("https://ipinfo.io/" + ipAddress + "/json");

  //var response = await fetch(res);
  //var text = await response.json();
  //console.log("Iptext:", response);
  if (res?.data?.ip) {
    //console.log("res.data:", res.data);
    return (
      res.data.city +
      ", " +
      res.data.region +
      ", " +
      res.data.country +
      " - " +
      res.data.postal
    );
  } else {
    return "";
  }
};

export const ConvertTextInputToArray = (inputValue) => {
  let finalData = [];
  if (inputValue != "" && inputValue != null) {
    const newArray = inputValue
      .split(/[\n,]/)
      .map((item) => item.trim())
      .filter((item) => item !== "");
    finalData = newArray;
  }
  return finalData;
};
export const isValidJSON = (str) => {
  try {
    JSON.parse(str);
    return true;
  } catch (error) {
    return false;
  }
};

export const shouldHideSpend = (authUserData) =>
  authUserData?.user_permissions?.includes("hide_spend") === true;

export const shouldHideCpm = (authUserData) =>
  authUserData?.user_permissions?.includes("hide_cpm") === true;

export const canViewConversions = (authUserData) =>
  authUserData?.is_sys_admin == 1 ||
  authUserData?.user_permissions?.includes("show_conversions") === true;

const REPORT_CONVERSION_PERMISSION_DEFINITIONS = [
  {
    field: "conversions",
    revenueField: "roi_1",
    costField: "conversion_cost_1",
    permission: "show_conversion_1",
    costPermission: "show_conversion_cost_1",
    revenuePermission: "show_conversion_revenue_1",
  },
  {
    field: "conversions_2",
    revenueField: "roi_2",
    costField: "conversion_cost_2",
    permission: "show_conversion_2",
    costPermission: "show_conversion_cost_2",
    revenuePermission: "show_conversion_revenue_2",
  },
  {
    field: "conversions_3",
    revenueField: "roi_3",
    costField: "conversion_cost_3",
    permission: "show_conversion_3",
    costPermission: "show_conversion_cost_3",
    revenuePermission: "show_conversion_revenue_3",
  },
  {
    field: "conversions_4",
    revenueField: "roi_4",
    costField: "conversion_cost_4",
    permission: "show_conversion_4",
    costPermission: "show_conversion_cost_4",
    revenuePermission: "show_conversion_revenue_4",
  },
];

export const getReportConversionPermissionName = (field = "conversions") =>
  REPORT_CONVERSION_PERMISSION_DEFINITIONS.find(
    (definition) => definition.field === field
  )?.permission || "";

export const hasGranularConversionPermissions = (authUserData) => {
  const permissions = Array.isArray(authUserData?.user_permissions)
    ? authUserData.user_permissions
    : [];
  return REPORT_CONVERSION_PERMISSION_DEFINITIONS.some(({ permission }) =>
    permissions.includes(permission)
  );
};

export const getReportConversionCostPermissionName = (
  field = "conversions"
) =>
  REPORT_CONVERSION_PERMISSION_DEFINITIONS.find(
    (definition) => definition.field === field
  )?.costPermission || "";

export const getReportConversionRevenuePermissionName = (
  field = "conversions"
) =>
  REPORT_CONVERSION_PERMISSION_DEFINITIONS.find(
    (definition) => definition.field === field
  )?.revenuePermission || "";

export const hasGranularConversionCostPermissions = (authUserData) => {
  const permissions = Array.isArray(authUserData?.user_permissions)
    ? authUserData.user_permissions
    : [];
  return REPORT_CONVERSION_PERMISSION_DEFINITIONS.some(({ costPermission }) =>
    permissions.includes(costPermission)
  );
};

export const hasGranularConversionRevenuePermissions = (authUserData) => {
  const permissions = Array.isArray(authUserData?.user_permissions)
    ? authUserData.user_permissions
    : [];
  return REPORT_CONVERSION_PERMISSION_DEFINITIONS.some(({ revenuePermission }) =>
    permissions.includes(revenuePermission)
  );
};

export const canViewConversionMetric = (
  authUserData,
  field = "conversions"
) => {
  if (!canViewConversions(authUserData)) return false;
  if (authUserData?.is_sys_admin == 1) return true;

  const permissionName = getReportConversionPermissionName(field);
  if (!permissionName) return true;
  if (!hasGranularConversionPermissions(authUserData)) return true;

  return authUserData?.user_permissions?.includes(permissionName) === true;
};

export const canViewConversionRevenueMetric = (
  authUserData,
  field = "conversions"
) => {
  if (!canViewRevenue(authUserData)) return false;
  if (!canViewConversionMetric(authUserData, field)) return false;
  if (authUserData?.is_sys_admin == 1) return true;

  const permissionName = getReportConversionRevenuePermissionName(field);
  if (!permissionName) return false;

  return authUserData?.user_permissions?.includes(permissionName) === true;
};

export const canViewRevenue = (authUserData) =>
  authUserData?.is_sys_admin == 1 ||
  authUserData?.user_permissions?.includes("show_roi_gross") === true;

export const canViewPrepaidBalance = (authUserData) =>
  authUserData?.is_sys_admin == 1 ||
  authUserData?.user_permissions?.includes("show_prepaid_balance") === true;

export const canUseVideoUrl = (authUserData) =>
  authUserData?.is_sys_admin == 1 ||
  authUserData?.user_permissions?.includes("enable_video_url") === true;

export const canUseVideoAssetUpload = (authUserData) =>
  authUserData?.is_sys_admin == 1 ||
  authUserData?.user_permissions?.includes("enable_video_asset_upload") ===
    true;

export const canViewGross = (authUserData) =>
  authUserData?.is_sys_admin == 1 ||
  authUserData?.user_permissions?.includes("show_gross") === true;

export const canViewConversionCost = (authUserData) =>
  !shouldHideSpend(authUserData) && canViewGross(authUserData);

export const canViewConversionCostMetric = (
  authUserData,
  field = "conversions"
) => {
  if (!canViewConversionCost(authUserData)) return false;
  if (!canViewConversionMetric(authUserData, field)) return false;
  if (authUserData?.is_sys_admin == 1) return true;

  const permissionName = getReportConversionCostPermissionName(field);
  if (!permissionName) return false;

  return authUserData?.user_permissions?.includes(permissionName) === true;
};

export const getReportConversionDefinitions = (conversionLabel = {}) => {
  const definitions = [
    {
      ...REPORT_CONVERSION_PERMISSION_DEFINITIONS[0],
      label: conversionLabel?.conv_1_label || "Conversions",
    },
  ];

  if (conversionLabel?.conv_2_label) {
    definitions.push({
      ...REPORT_CONVERSION_PERMISSION_DEFINITIONS[1],
      label: conversionLabel.conv_2_label,
    });
  }
  if (conversionLabel?.conv_3_label) {
    definitions.push({
      ...REPORT_CONVERSION_PERMISSION_DEFINITIONS[2],
      label: conversionLabel.conv_3_label,
    });
  }
  if (conversionLabel?.conv_4_label) {
    definitions.push({
      ...REPORT_CONVERSION_PERMISSION_DEFINITIONS[3],
      label: conversionLabel.conv_4_label,
    });
  }

  return definitions;
};

export const getReportConversionMetricConfigs = ({
  conversionLabel = {},
  hideReportMetrics = [],
  authUserData,
}) => {
  if (!canViewConversions(authUserData)) return [];
  const hidden = new Set(Array.isArray(hideReportMetrics) ? hideReportMetrics : []);
  return getReportConversionDefinitions(conversionLabel).filter(
    ({ field }) =>
      !hidden.has(field) && canViewConversionMetric(authUserData, field)
  ).map((metricInfo) => ({
    ...metricInfo,
    canViewCost: canViewConversionCostMetric(authUserData, metricInfo.field),
    canViewRevenue: canViewConversionRevenueMetric(
      authUserData,
      metricInfo.field
    ),
  }));
};

export const getReportConversionCostMetricConfigs = ({
  conversionLabel = {},
  hideReportMetrics = [],
  authUserData,
}) => {
  if (!canViewConversionCost(authUserData)) return [];
  const hidden = new Set(Array.isArray(hideReportMetrics) ? hideReportMetrics : []);
  if (hidden.has("conversion_cost_gross")) return [];

  return getReportConversionDefinitions(conversionLabel).filter(
    ({ field, costField }) =>
      canViewConversionCostMetric(authUserData, field) && !hidden.has(costField)
  );
};

export const getReportRevenueMetricConfigs = ({
  conversionLabel = {},
  hideReportMetrics = [],
  authUserData,
}) => {
  if (!canViewRevenue(authUserData)) return [];
  const hidden = new Set(Array.isArray(hideReportMetrics) ? hideReportMetrics : []);
  if (hidden.has("conversion_roi") || hidden.has("roi")) return [];
  return getReportConversionDefinitions(conversionLabel).filter(
    ({ field, revenueField }) =>
      canViewConversionRevenueMetric(authUserData, field) &&
      !hidden.has(revenueField)
  );
};

export const getTotalReportConversions = (row = {}, conversionDefinitions = []) =>
  conversionDefinitions.reduce(
    (sum, metricInfo) => sum + Number(row?.[metricInfo.field] || 0),
    0
  );

export const getTotalReportRevenue = (row = {}, revenueMetrics = []) =>
  revenueMetrics.reduce(
    (sum, metricInfo) => sum + Number(row?.[metricInfo.revenueField] || 0),
    0
  );

export const getTotalReportConversionCost = (row = {}, conversionDefinitions = []) => {
  const totalConversions = getTotalReportConversions(row, conversionDefinitions);
  const spend = Number(row?.spend || 0);
  if (totalConversions <= 0 || spend <= 0) return 0;
  return Number((spend / totalConversions).toFixed(2));
};

export const getReportConversionCostLabel = (label = "") => {
  const compactLabel = String(label || "")
    .replace(/[^a-zA-Z0-9]/g, "")
    .toUpperCase();

  if (compactLabel === "SP") return "CPSP";
  if (compactLabel === "FTD") return "CPFTD";
  if (compactLabel === "RD") return "CPRD";
  if (!label) return "Cost";

  return `Cost (${label})`;
};

export const getEstimatedReportConversionField = (field = "conversions") =>
  field === "conversions"
    ? "estimatedConversions"
    : `estimated${field.replace("conversions_", "Conversions_")}`;

export const getEstimatedReportRevenueField = (revenueField = "roi") =>
  revenueField === "roi"
    ? "estimatedRevenue"
    : `estimated${revenueField.replace("roi_", "Revenue_")}`;

export const withPermissionHiddenReportMetrics = (
  metrics = [],
  authUserData
) => {
  const hidden = new Set(Array.isArray(metrics) ? metrics : []);

  REPORT_CONVERSION_PERMISSION_DEFINITIONS.forEach(
    ({ field, revenueField, costField }) => {
      if (!canViewConversionMetric(authUserData, field)) {
        hidden.add(field);
      }
      if (!canViewConversionRevenueMetric(authUserData, field)) {
        hidden.add(revenueField);
      }
      if (!canViewConversionCostMetric(authUserData, field)) {
        hidden.add(costField);
      }
    }
  );

  if (shouldHideSpend(authUserData)) {
    hidden.add("spend");
    hidden.add("gross");
    hidden.add("Gross");
    hidden.add("total_delivered_budget");
    hidden.add("conversion_cost_gross");
    hidden.add("conversion_roi");
    hidden.add("roi");
    hidden.add("profit");
  }
  if (!canViewConversions(authUserData)) {
    hidden.add("conversions");
    hidden.add("conversions_2");
    hidden.add("conversions_3");
    hidden.add("conversions_4");
  }
  if (!canViewRevenue(authUserData)) {
    hidden.add("conversion_cost_net");
    hidden.add("conversion_roi");
    hidden.add("roi");
    hidden.add("roi_1");
    hidden.add("roi_2");
    hidden.add("roi_3");
    hidden.add("roi_4");
  }
  if (!canViewConversionCost(authUserData)) {
    hidden.add("conversion_cost_gross");
    hidden.add("conversion_cost_1");
    hidden.add("conversion_cost_2");
    hidden.add("conversion_cost_3");
    hidden.add("conversion_cost_4");
  }
  if (shouldHideSpend(authUserData) || shouldHideCpm(authUserData)) {
    hidden.add("pb");
    hidden.add("eb");
    hidden.add("planned_budget");
    hidden.add("expected_budget");
    hidden.add("total_budget");
  }
  if (shouldHideCpm(authUserData)) {
    hidden.add("cpm");
    hidden.add("ecpm");
    hidden.add("gecpm");
    hidden.add("ppm");
  }
  return Array.from(hidden);
};

export const stripPermissionHiddenReportFields = (rows = [], authUserData) => {
  if (!Array.isArray(rows)) return rows;

  const hideSpend = shouldHideSpend(authUserData);
  const hideCpm = shouldHideCpm(authUserData);

  const spendKeys = [
    "spend",
    "Spend",
    "Gross",
    "gross",
    "total_delivered_budget",
    "conversion_cost_gross",
    "conversion_cost_net",
    "conversion_roi",
    "roi",
    "roi_1",
    "roi_2",
    "roi_3",
    "roi_4",
    "profit",
  ];
  const permissionHiddenKeys = new Set();
  REPORT_CONVERSION_PERMISSION_DEFINITIONS.forEach(
    ({ field, revenueField, costField }) => {
      if (!canViewConversionMetric(authUserData, field)) {
        permissionHiddenKeys.add(field);
      }
      if (!canViewConversionRevenueMetric(authUserData, field)) {
        permissionHiddenKeys.add(revenueField);
      }
      if (!canViewConversionCostMetric(authUserData, field)) {
        permissionHiddenKeys.add(costField);
      }
    }
  );
  if (!canViewRevenue(authUserData)) {
    permissionHiddenKeys.add("conversion_roi");
    permissionHiddenKeys.add("roi");
  }
  if (!canViewConversionCost(authUserData)) {
    permissionHiddenKeys.add("conversion_cost_gross");
  }
  const budgetKeys = [
    "pb",
    "eb",
    "planned_budget",
    "expected_budget",
    "total_budget",
    "Budget",
    "Planned Budget",
    "Expected Budget",
  ];
  const cpmKeys = [
    "cpm",
    "CPM",
    "ecpm",
    "eCPM",
    "gecpm",
    "GeCPM",
    "ppm",
    "PPM",
    "bidder_gecpm",
    "difference_gecpm",
    "bidder_soft_limit",
    "Expected GeCPM",
    "% Difference GeCPM",
    "Min. Expected GeCPM",
  ];

  return rows.map((row) => {
    if (!row || typeof row !== "object") return row;
    const next = { ...row };
    permissionHiddenKeys.forEach((key) => delete next[key]);
    if (hideSpend) {
      spendKeys.forEach((key) => delete next[key]);
    }
    if (hideSpend || hideCpm) {
      budgetKeys.forEach((key) => delete next[key]);
    }
    if (hideCpm) {
      cpmKeys.forEach((key) => delete next[key]);
    }
    return next;
  });
};

export const preparePreDefinedProps = (
  dashboardPreInfo,
  summary_options_ext,
  authUserData,
  profile_type
) => {
  // console.log("Inside:", preparePreDefinedProps);
  let summaryFilters =
    dashboardPreInfo?.showsummaryfilters &&
    dashboardPreInfo?.showsummaryfilters.length > 0
      ? dashboardPreInfo?.showsummaryfilters
      : [];

  let is_sys_admin = authUserData?.is_sys_admin;
  let isShowRevenue =
    authUserData.user_permissions?.includes("show_revenues") == true ? 1 : 0; //authUserData?.show_revenues;
  let isShowNet =
    authUserData.user_permissions?.includes("show_net") == true ? 1 : 0; //authUserData?.show_net;
  let isShowGross =
    authUserData.user_permissions?.includes("show_gross") == true ? 1 : 0; //authUserData?.show_gross;
  let isShowWins =
    authUserData.user_permissions?.includes("show_wins") == true ? 1 : 0; //authUserData?.show_wins;
  let userPermissions = authUserData?.user_permissions;
  const hideSpend = shouldHideSpend(authUserData);
  const hideCpm = shouldHideCpm(authUserData);

  if (hideSpend) {
    delete summary_options_ext["revenue"];
  }

  if (hideCpm) {
    delete summary_options_ext["ecpm"];
    delete summary_options_ext["gecpm"];
    delete summary_options_ext["ppm"];
  }

  if (is_sys_admin !== 1) {
    delete summary_options_ext["load"];
    delete summary_options_ext["adrenders"];
    delete summary_options_ext["aderrors"];
    delete summary_options_ext["pubbidprice"];
    delete summary_options_ext["ewins"];
    delete summary_options_ext["eloss"];
  }

  if (is_sys_admin !== 1 && isShowRevenue !== 1) {
    if (profile_type !== "publisher" && profile_type !== "bidder") {
      delete summary_options_ext["winbids"];
    }
    delete summary_options_ext["ipfrauds"];
    delete summary_options_ext["uafrauds"];
    delete summary_options_ext["reffrauds"];
    delete summary_options_ext["losebids"];
    delete summary_options_ext["avgwinprice"];
    delete summary_options_ext["avgloseprice"];
    delete summary_options_ext["avgdiscardprice"];
    delete summary_options_ext["avgfinalprice"];
    delete summary_options_ext["avgfloor"];
  }

  if (is_sys_admin !== 1 && isShowNet !== 1) {
    delete summary_options_ext["netrevenue"];
  }

  // if (SHOW_NET_WITH_MARGIN && userPermissions?.["show_net_with_margin"]) {
  //     delete summary_options_ext['netrevenue'];
  // }

  if (is_sys_admin !== 1 && isShowGross !== 1) {
    delete summary_options_ext["revenue"];
  }

  if (is_sys_admin !== 1) {
    delete summary_options_ext["viewable"];
    if (profile_type === "advertiser") {
      if (isShowNet !== 1) {
        delete summary_options_ext["netrevenue"];
      }
    }

    if (profile_type === "publisher") {
      if (isShowGross !== 1) {
        delete summary_options_ext["revenue"];
      }
      if (isShowWins !== 1) {
        delete summary_options_ext["winbids"];
      }
    }

    if (profile_type === "bidder") {
      if (isShowNet !== 1) {
        delete summary_options_ext["netrevenue"];
      }
      if (isShowWins !== 1) {
        delete summary_options_ext["winbids"];
      }
    }
  }

  let defaultSortKey = null;
  let defaultSortMaxTileKey = null;

  for (const [key, value] of Object.entries(summary_options_ext)) {
    if (value.default_sort === true) {
      defaultSortKey = key;
    }
    if (value.default_sort_max_tile === true) {
      defaultSortMaxTileKey = key;
    }
  }

  let graphs = {};
  let summaryOptions = {};
  let currentGraphKey = null;
  let detailAggs = [];
  let showSummaryFilters = {};

  if (summaryFilters && summaryFilters.length > 0) {
    summaryFilters.forEach((key, index) => {
      const graphType = key;
      summaryOptions[key] = summary_options_ext[key].label;

      if (index === 0) {
        currentGraphKey = graphType;
      }

      graphs[graphType] = {
        key: key,
        value: summary_options_ext[key].label,
        prefix: "",
        color: summary_options_ext[key].color,
        label: summary_options_ext[key].label,
      };

      detailAggs.push(key);
    });

    if (!detailAggs.includes(defaultSortMaxTileKey)) {
      detailAggs.push(defaultSortMaxTileKey);
    }

    detailAggs = JSON.stringify(detailAggs);
  } else {
    let sumInc = 0;

    for (const [key, value] of Object.entries(summary_options_ext)) {
      const graphType = key;
      summaryFilters.push(key);
      summaryOptions[key] = value.label;

      if (sumInc === 0) {
        currentGraphKey = graphType;
      }

      graphs[graphType] = {
        key: key,
        value: value.label,
        prefix: "",
        color: value.color,
        label: value.label,
      };

      detailAggs.push(key);
      sumInc++;
    }

    showSummaryFilters = summaryFilters;
    detailAggs = showSummaryFilters;
  }

  return {
    graphs: graphs,
    detailAggs: detailAggs,
    summary_options_ext: summary_options_ext,
    showsummaryfilters: showSummaryFilters,
    summaryOptions: summaryOptions,
    default_sort_key: defaultSortKey,
    default_sort_max_tile_key: defaultSortMaxTileKey,
    drawGraphs: detailAggs,
    dataView: profile_type,
    currentGraphKey: currentGraphKey,
  };
};

export const setDefaultMustFilters = (
  authUserData,
  profile_type,
  dashboardPreInfo,
  campaignIdArr = [],
  globalCampaignsList,
  globalPublishersList,
  globalBiddersList
) => {
  let mustFilters = {};
  let filterBars = {};
  let campaignLabel = "";
  let accountIds =
    Object.keys(authUserData?.user_assoc_accounts).length > 0 &&
    authUserData?.user_assoc_accounts?.[profile_type]
      ? authUserData?.user_assoc_accounts?.[profile_type]
      : [];
  let is_sys_admin = authUserData?.is_sys_admin;
  let internalDspIds = dashboardPreInfo?.internalDspsInfo
    ? dashboardPreInfo?.internalDspsInfo
    : {};
  let internalDspIdsArr =
    Object.keys(internalDspIds).length > 0 ? Object.keys(internalDspIds) : [];

  if (campaignIdArr.length > 0) {
    console.log("globalCampaignsList:", globalCampaignsList);

    const foundItem = globalCampaignsList.find(
      (item) => item.value == campaignIdArr[0]
    );

    campaignLabel = foundItem?.label
      ? foundItem?.label + " [ID:" + foundItem?.value + "]"
      : " [ID:" + campaignIdArr[0] + "]";

    mustFilters["V"] = campaignIdArr;
    if (campaignIdArr.length > 0) {
      let tableId = "V";
      let header = "Campaign ID";

      for (let k = 0; k < campaignIdArr.length; k++) {
        let uniqKey = "V_" + campaignIdArr[k];
        let rowId = campaignIdArr[k];
        filterBars = {
          ...filterBars,
          [uniqKey]: {
            tableId: tableId,
            rowId: rowId,
            label: rowId,
            header: header,
            invert: false,
            hidden: false,
          },
        };
      }
    }

    if (internalDspIdsArr.length > 0) {
      mustFilters["R"] = internalDspIdsArr;

      if (internalDspIdsArr.length > 0) {
        let tableId = "R";
        let header = "Bidder";

        for (let k = 0; k < internalDspIdsArr.length; k++) {
          let uniqKey = "R_" + internalDspIdsArr[k];
          let rowId = internalDspIdsArr[k];
          filterBars = {
            ...filterBars,
            [uniqKey]: {
              tableId: tableId,
              rowId: rowId,
              label: internalDspIds?.[rowId] ? internalDspIds?.[rowId] : rowId,
              header: header,
              invert: false,
              hidden: false,
            },
          };
        }
      }
    }

    if (is_sys_admin != 1) {
      mustFilters["E1"] = accountIds;

      let tableId = "E1";
      let header = "Account";

      for (let k = 0; k < accountIds.length; k++) {
        let uniqKey = "E1_" + accountIds[k];
        let rowId = accountIds[k];
        filterBars = {
          ...filterBars,
          [uniqKey]: {
            tableId: tableId,
            rowId: rowId,
            label: rowId,
            header: header,
            invert: false,
            hidden: true,
          },
        };
      }
    }
  } else {
    if (is_sys_admin != 1) {
      if (profile_type != "publisher") {
        mustFilters["E1"] = accountIds;
        let tableId = "E1";
        let header = "Account";

        for (let k = 0; k < accountIds.length; k++) {
          let uniqKey = "E1_" + accountIds[k];
          let rowId = accountIds[k];
          filterBars = {
            ...filterBars,
            [uniqKey]: {
              tableId: tableId,
              rowId: rowId,
              label: rowId,
              header: header,
              invert: false,
              hidden: true,
            },
          };
        }
      }

      if (profile_type == "publisher") {
        if (globalPublishersList.length > 0) {
          let tableId = "A";
          let header = "Publisher";
          for (let n = 0; n < globalPublishersList.length; n++) {
            if (globalPublishersList[n]["pub_code"] != "") {
              let pubcode = globalPublishersList[n]["pub_code"];
              if (!mustFilters?.["A"]) {
                mustFilters["A"] = [];
              }
              mustFilters["A"].push(pubcode);

              let uniqKey = "A_" + pubcode;
              let rowId = pubcode;
              filterBars = {
                ...filterBars,
                [uniqKey]: {
                  tableId: tableId,
                  rowId: rowId,
                  label: rowId,
                  header: header,
                  invert: false,
                  hidden: true,
                },
              };
            }
          }
        } else {
          mustFilters["E1"] = accountIds;
          let tableId = "E1";
          let header = "Account";
          for (let k = 0; k < accountIds.length; k++) {
            let uniqKey = "E1_" + accountIds[k];
            let rowId = accountIds[k];
            filterBars = {
              ...filterBars,
              [uniqKey]: {
                tableId: tableId,
                rowId: rowId,
                label: rowId,
                header: header,
                invert: false,
                hidden: true,
              },
            };
          }
        }
      }

      if (profile_type == "bidder") {
        if (globalBiddersList.length > 0) {
          let tableId = "R";
          let header = "Bidder";
          for (let n = 0; n < globalBiddersList.length; n++) {
            if (globalBiddersList[n]["value"] != "") {
              let bidderId = globalBiddersList[n]["value"];
              if (!mustFilters?.["R"]) {
                mustFilters["R"] = [];
              }
              mustFilters["R"].push(bidderId);

              let uniqKey = "R_" + bidderId;
              let rowId = bidderId;
              filterBars = {
                ...filterBars,
                [uniqKey]: {
                  tableId: tableId,
                  rowId: rowId,
                  label: rowId,
                  header: header,
                  invert: false,
                  hidden: true,
                },
              };
            }
          }
        }
      }
    }
  }

  return { mustFilters, filterBars, campaignLabel: campaignLabel };
};

export const prepareSupplyDashboardPreDefinedProps = (
  dashboardPreInfo,
  summary_options_ext,
  authUserData,
  profile_type
) => {
  // console.log("Inside:", preparePreDefinedProps);
  let summaryFilters =
    dashboardPreInfo?.showsummaryfilters &&
    dashboardPreInfo?.showsummaryfilters.length > 0
      ? dashboardPreInfo?.showsummaryfilters
      : [];

  let is_sys_admin = authUserData?.is_sys_admin;
  let isShowRevenue =
    authUserData.user_permissions?.includes("show_revenues") == true ? 1 : 0; //authUserData?.show_revenues;
  let isShowNet =
    authUserData.user_permissions?.includes("show_net") == true ? 1 : 0; //authUserData?.show_net;
  let isShowGross =
    authUserData.user_permissions?.includes("show_gross") == true ? 1 : 0; //authUserData?.show_gross;
  let isShowWins =
    authUserData.user_permissions?.includes("show_wins") == true ? 1 : 0; //authUserData?.show_wins;
  let userPermissions = authUserData?.user_permissions;
  let showPrices = authUserData?.supply_dashboard_show_prices;
  const hideSpend = shouldHideSpend(authUserData);
  const hideCpm = shouldHideCpm(authUserData);

  if (hideSpend) {
    delete summary_options_ext["revenue"];
  }

  if (hideCpm) {
    delete summary_options_ext["ecpm"];
    delete summary_options_ext["gecpm"];
    delete summary_options_ext["ppm"];
  }

  if (is_sys_admin !== 1 && showPrices !== 1) {
    // delete summary_options_ext["avgbasefloor"];
    //delete summary_options_ext["avgpubfloor"];
  }

  let defaultSortKey = null;
  let defaultSortMaxTileKey = null;

  for (const [key, value] of Object.entries(summary_options_ext)) {
    if (value.default_sort === true) {
      defaultSortKey = key;
    }
    if (value.default_sort_max_tile === true) {
      defaultSortMaxTileKey = key;
    }
  }

  let graphs = {};
  let summaryOptions = {};
  let currentGraphKey = null;
  let detailAggs = [];
  let showSummaryFilters = {};

  if (summaryFilters && summaryFilters.length > 0) {
    summaryFilters.forEach((key, index) => {
      const graphType = key;
      summaryOptions[key] = summary_options_ext[key].label;

      if (index === 0) {
        currentGraphKey = graphType;
      }

      graphs[graphType] = {
        key: key,
        value: summary_options_ext[key].label,
        prefix: "",
        color: summary_options_ext[key].color,
        label: summary_options_ext[key].label,
      };

      detailAggs.push(key);
    });

    if (!detailAggs.includes(defaultSortMaxTileKey)) {
      detailAggs.push(defaultSortMaxTileKey);
    }

    detailAggs = JSON.stringify(detailAggs);
  } else {
    let sumInc = 0;

    for (const [key, value] of Object.entries(summary_options_ext)) {
      const graphType = key;
      summaryFilters.push(key);
      summaryOptions[key] = value.label;

      if (sumInc === 0) {
        currentGraphKey = graphType;
      }

      graphs[graphType] = {
        key: key,
        value: value.label,
        prefix: "",
        color: value.color,
        label: value.label,
      };

      detailAggs.push(key);
      sumInc++;
    }

    showSummaryFilters = summaryFilters;
    detailAggs = showSummaryFilters;
  }

  return {
    graphs: graphs,
    detailAggs: detailAggs,
    summary_options_ext: summary_options_ext,
    showsummaryfilters: showSummaryFilters,
    summaryOptions: summaryOptions,
    default_sort_key: defaultSortKey,
    default_sort_max_tile_key: defaultSortMaxTileKey,
    drawGraphs: detailAggs,
    dataView: profile_type,
    currentGraphKey: currentGraphKey,
  };
};

export const setDefaultMustFiltersForSupplyDashboard = (
  authUserData,
  profile_type,
  dashboardPreInfo,
  campaignIdArr = [],
  globalCampaignsList
) => {
  let mustFilters = {};
  let filterBars = {};
  let campaignLabel = "";
  let accountIds =
    Object.keys(authUserData?.user_assoc_accounts).length > 0 &&
    authUserData?.user_assoc_accounts?.[profile_type]
      ? authUserData?.user_assoc_accounts?.[profile_type]
      : [];
  let is_sys_admin = authUserData?.is_sys_admin;

  //if (campaignIdArr.length > 0) {
  if (is_sys_admin != 1) {
    let accountsToShow =
      authUserData?.supply_dashboard_accounts &&
      authUserData?.supply_dashboard_accounts != ""
        ? authUserData?.supply_dashboard_accounts.split(",")
        : [];
    if (accountsToShow.length > 0) {
      mustFilters["AR"] = accountsToShow;
      let tableId = "AR";
      let header = "Account";

      for (let k = 0; k < accountsToShow.length; k++) {
        let uniqKey = "AR_" + accountsToShow[k];
        let rowId = accountsToShow[k];
        filterBars = {
          ...filterBars,
          [uniqKey]: {
            tableId: tableId,
            rowId: rowId,
            label: rowId,
            header: header,
            invert: false,
            hidden: true,
          },
        };
      }
    }
  }
  //}

  return { mustFilters, filterBars, campaignLabel: campaignLabel };
};

export const convertValuesToNumber = (obj) => {
  const newObj = {};
  for (const key in obj) {
    if (typeof obj[key] === "object") {
      // If the current value is an object, recursively call the function
      newObj[key] = convertValuesToNumber(obj[key]);
    } else if (!isNaN(obj[key])) {
      // If the current value is a number represented as a string, convert it to a number
      newObj[key] = Number(obj[key]);
    } else {
      newObj[key] = obj[key];
    }
  }
  return newObj;
};
export const check90dJavascriptBannerMarkup = (adMarkup = "") => {
  let isPresent = false;
  if (adMarkup == "" || adMarkup == null || adMarkup == undefined) {
    return isPresent;
  }
  var regex = /"https:\/\/[a-zA-Z0-9-]+\.90d\.io\//;
  var regex1 = /RenderStory/;
  if (regex.test(adMarkup) && regex1.test(adMarkup)) {
    isPresent = true;
  }

  return isPresent;
};

export const containsOnlyLettersAndNumbers = (inputString) => {
  // Define a regular expression pattern for letters and numbers
  var pattern = /^[a-zA-Z0-9]+$/;

  // Test if the input string matches the pattern
  return pattern.test(inputString);
};

export const prepareSegmentsConditionsUI = (dbSegmentsConditions) => {
  let SelectedSegments =
    dbSegmentsConditions != "" &&
    dbSegmentsConditions != null &&
    dbSegmentsConditions != undefined
      ? parseJsonString(dbSegmentsConditions)
      : {};

  if (
    Object.keys(SelectedSegments).length > 0 &&
    (SelectedSegments.hasOwnProperty("OR") ||
      SelectedSegments.hasOwnProperty("AND"))
  ) {
    let oldDbUI = {};
    for (let key in SelectedSegments) {
      let segGroupInfo = SelectedSegments[key];
      if (key == "OR") {
        for (let segment in segGroupInfo) {
          let segInfo = segGroupInfo[segment];
          if (!oldDbUI.hasOwnProperty(segment)) {
            oldDbUI[segment] = {};
          }
          oldDbUI[segment].orGroup = [];
          for (let segKey in segInfo) {
            oldDbUI[segment].orGroup.push(segInfo[segKey]);
          }
        }
      } else if (key == "AND") {
        for (let segment in segGroupInfo) {
          let segInfo = segGroupInfo[segment];
          if (!oldDbUI.hasOwnProperty(segment)) {
            oldDbUI[segment] = {};
          }
          for (let ANDGroup in segInfo) {
            let andId = ANDGroup.replace("group_", "ANDGroup_");
            oldDbUI[segment][andId] = [];
            for (let segkey in segInfo[ANDGroup]) {
              oldDbUI[segment][andId].push(segInfo[ANDGroup][segkey]);
            }
          }

          // oldDbUI[segment].orGroup = [segInfo];
        }
      }
    }
    return oldDbUI;
  } else {
    return SelectedSegments;
  }
};
export const compareTwoObjects = (presentObj, prevObj) => {
  let hasChanges = false;
  for (const key in prevObj) {
    if (presentObj.hasOwnProperty(key)) {
      if (presentObj[key] != prevObj[key]) {
        console.log("key", key);
        if (key == "target_poi") {
          if (presentObj[key].length != prevObj[key].length) {
            hasChanges = true;
            break;
          }
        } else {
          hasChanges = true;
          break;
        }
      }
    }
  }
  return hasChanges;
};

export const getInventoryTargetingChanges = (formData) => {
  let inventoryTargetingValues = {};
  if (formData.update_inventory_tab) {
    inventoryTargetingValues["target_skippable"] =
      formData.target_skippable != "" && formData.target_skippable != null
        ? formData.target_skippable.split(",").sort().join(",")
        : "";
    inventoryTargetingValues["target_app"] =
      formData.target_app != "" && formData.target_app != null
        ? formData.target_app.split(",").sort().join(",")
        : "";
    inventoryTargetingValues["target_app_language"] =
      formData.target_app_language != "" && formData.target_app_language != null
        ? formData.target_app_language.split(",").sort().join(",")
        : "";
    inventoryTargetingValues["target_cats"] =
      formData.target_cats != "" && formData.target_cats != null
        ? formData.target_cats.split(",").sort().join(",")
        : "";
    inventoryTargetingValues["target_pubs"] =
      formData.target_pubs != "" && formData.target_pubs != null
        ? formData.target_pubs.split(",").sort().join(",")
        : "";
    inventoryTargetingValues["target_placements"] =
      formData.target_placements != "" && formData.target_placements != null
        ? formData.target_placements.split(",").sort().join(",")
        : "";
    inventoryTargetingValues["target_supply_deal_id"] =
      formData.target_supply_deal_id != "" &&
      formData.target_supply_deal_id != null
        ? formData.target_supply_deal_id.split(",").sort().join(",")
        : "";
    inventoryTargetingValues["target_bundles"] =
      formData.target_bundles != "" && formData.target_bundles != null
        ? formData.target_bundles.split(",").sort().join(",")
        : "";
  }
  inventoryTargetingValues["target_gender"] =
    formData.target_gender != "" && formData.target_gender != null
      ? formData.target_gender.split(",").sort().join(",")
      : "";
  inventoryTargetingValues["target_age"] =
    formData.target_age != "" && formData.target_age != null
      ? formData.target_age.split(",").sort().join(",")
      : "";
  inventoryTargetingValues["target_device_os"] =
    formData.target_device_os != "" && formData.target_device_os != null
      ? formData.target_device_os.split(",").sort().join(",")
      : "";
  inventoryTargetingValues["target_connectiontype"] =
    formData.target_connectiontype != "" &&
    formData.target_connectiontype != null
      ? formData.target_connectiontype.split(",").sort().join(",")
      : "";
  inventoryTargetingValues["target_devicetype"] =
    formData.target_devicetype != "" && formData.target_devicetype != null
      ? formData.target_devicetype.split(",").sort().join(",")
      : "";
  inventoryTargetingValues["target_segments"] =
    formData.target_segments != "" && formData.target_segments != null
      ? formData.target_segments.split(",").sort().join(",")
      : "";

  inventoryTargetingValues["segments_conditions"] =
    formData.segments_conditions != "" && formData.segments_conditions != null
      ? formData.segments_conditions
      : "";

  inventoryTargetingValues["target_days"] =
    formData.target_days != "" && formData.target_days != null
      ? formData.target_days
      : "";

  inventoryTargetingValues["target_hours"] =
    formData.target_hours != "" && formData.target_hours != null
      ? formData.target_hours
      : "";

  return inventoryTargetingValues;
};

export const getTodayDateBasedOnTimeZone = (timezone) => {
  let momentDate = moment().tz(timezone);
  // Get the year, month, date, hour, minute, second, and millisecond components
  const year = momentDate.year();
  const month = momentDate.month();
  const date = momentDate.date();
  const hour = momentDate.hour();
  const minute = momentDate.minute();
  const second = momentDate.second();
  const millisecond = momentDate.millisecond();

  // Create a new JavaScript Date object with these components
  const dateObject = new Date(
    year,
    month,
    date,
    hour,
    minute,
    second,
    millisecond
  );

  return dateObject;
};

export async function bannerEncrypt(input, skey) {
  const secretKey = skey; // You should securely store and retrieve your key

  // Convert the key to a format that can be used by CryptoJS
  const key = CryptoJS.enc.Utf8.parse(secretKey);
  const iv = CryptoJS.enc.Utf8.parse(secretKey.substring(0, 16)); // For AES, block size is 16 bytes

  const encrypted = CryptoJS.AES.encrypt(input, key, {
    iv: iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypted.toString();
}

export async function bannerDecrypt(encrypted, skey) {
  const secretKey = skey; // You should securely store and retrieve your key

  // Convert the key to a format that can be used by CryptoJS
  const key = CryptoJS.enc.Utf8.parse(secretKey);
  const iv = CryptoJS.enc.Utf8.parse(secretKey.substring(0, 16)); // For AES, block size is 16 bytes

  const decrypted = CryptoJS.AES.decrypt(encrypted, key, {
    iv: iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });

  return decrypted.toString(CryptoJS.enc.Utf8);
}

export const generateBannerPreviewLink = (
  bannerInfo,
  encryptedBannerId,
  previewBaseURL
) => {
  // $bannerId=urlencode(Security::encrypt($bannerInfo['id'], BANNER_PREVIEW_AES_PASSWORD));
  let target_orientation =
    bannerInfo["target_orientation"] != "" &&
    bannerInfo["target_orientation"] != null
      ? bannerInfo["target_orientation"]
      : "0,1";
  let width = 0;
  let height = 0;
  const btype = bannerInfo["imp_type"];
  const bResolutionArr = bannerInfo["target_size"].split(",");
  let highestArea = 0;
  let i = 1;
  bResolutionArr.forEach((singleRes) => {
    if (target_orientation !== "1" && i % 2 !== 0) {
      const singleResArr = singleRes.split("x");
      const area =
        parseInt(singleResArr[0], 10) * parseInt(singleResArr[1], 10);
      if (area === highestArea && parseInt(singleResArr[0], 10) > width) {
        highestArea = area;
        width = parseInt(singleResArr[0], 10);
        height = parseInt(singleResArr[1], 10);
      } else if (area > highestArea) {
        highestArea = area;
        width = parseInt(singleResArr[0], 10);
        height = parseInt(singleResArr[1], 10);
      }
    } else if (target_orientation === "1") {
      const singleResArr = singleRes.split("x");
      const area =
        parseInt(singleResArr[0], 10) * parseInt(singleResArr[1], 10);
      if (area === highestArea && parseInt(singleResArr[0], 10) > width) {
        highestArea = area;
        width = parseInt(singleResArr[0], 10);
        height = parseInt(singleResArr[1], 10);
      } else if (area > highestArea) {
        highestArea = area;
        width = parseInt(singleResArr[0], 10);
        height = parseInt(singleResArr[1], 10);
      }
    }
    i++;
  });

  if (width === 0 && height === 0) {
    width = 1;
    height = 1;
  }

  const bannerPreviewLink = previewBaseURL
    .replace("{WIDTH}", width)
    .replace("{HEIGHT}", height)
    .replace("{AES_BANNER_ID}", encodeURIComponent(encryptedBannerId)) // Uncomment this line when needed
    .replace("{BANNER_TYPE}", btype);

  return bannerPreviewLink;
};

const getParentHostDomain = (host = "") => {
  const normalizedHost = String(host || "")
    .trim()
    .toLowerCase()
    .split(":")[0];

  if (
    normalizedHost === "" ||
    normalizedHost === "localhost" ||
    /^\d{1,3}(\.\d{1,3}){3}$/.test(normalizedHost)
  ) {
    return "";
  }

  const hostParts = normalizedHost.split(".").filter(Boolean);
  if (hostParts.length < 2) {
    return "";
  }

  return hostParts.slice(-2).join(".");
};

export const resolveBannerPreviewBaseUrl = ({
  currentHost = "",
  pixelDomain = "",
} = {}) => {
  const normalizedPixelDomain = String(pixelDomain || "").trim().toLowerCase();
  if (
    normalizedPixelDomain !== "" &&
    DOMAIN_PREVIEW_URLS?.[normalizedPixelDomain]
  ) {
    return DOMAIN_PREVIEW_URLS[normalizedPixelDomain];
  }

  const parentDomain = getParentHostDomain(currentHost);
  if (parentDomain !== "") {
    return BANNER_PREVIEW_URL.replace(
      "nep.advangelists.com",
      `nep.${parentDomain}`
    );
  }

  return BANNER_PREVIEW_URL;
};

// Function to get unique audience providers
export const getUniqueAudienceProviders = (accounts) => {
  const allProviders = accounts
    .map((account) => account.audience_providers) // Extract the audience_providers strings
    .flatMap((providers) => providers.split(",")) // Split each string into an array and flatten the arrays
    .map((provider) => provider.trim()) // Trim any whitespace from each provider
    .filter((provider) => provider.length > 0); // Filter out empty strings

  // Create a Set to get unique values, then convert back to an array
  const uniqueProviders = Array.from(new Set(allProviders));
  return uniqueProviders;
};

// Function to get all IDs where is_seat_on_platform is 2
export const getIdsWithSpecificValue = (array, key, value) => {
  return array.filter((item) => item[key] === value).map((item) => item.value);
};
